export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-background-100 text-foreground-700">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-lg"></i>
              </span>
              <span className="heading-font text-xl font-bold text-foreground-950">海角吃瓜</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed">
              以清晰时间线、客观信息分级与持续更新为原则的事件追踪平台。我们不做情绪推手，只做真相路上的整理者，帮你一次理清海角吃瓜事件始末与后续进展。
            </p>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground-950">内容导航</h4>
            <ul className="mt-4 space-y-3">
              {[
                ['#timeline', '事件时间线'],
                ['#topics', '热点追踪'],
                ['#facts', '真相梳理'],
                ['#faq', '常见问题'],
              ].map(([href, label]) => (
                <li key={href}>
                  <a href={href} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">{label}</a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground-950">关于本站</h4>
            <ul className="mt-4 space-y-3">
              {[
                ['#about', '关于我们'],
                ['#facts', '内容原则'],
                ['#subscribe', '关注进展'],
              ].map(([href, label]) => (
                <li key={href}>
                  <a href={href} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">{label}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 海角吃瓜 · 本站内容均整理自公开信息，仅供信息参考。</p>
          <p className="whitespace-nowrap">邮箱：contact@haijiaochigua.cn</p>
        </div>
      </div>
    </footer>
  );
}